/**
 * Currency Exchange Rates
 * Base currency: EUR (Euro)
 * Rates as of: November 26, 2025 (ECB reference rates)
 * 
 * Note: SEK, NOK, CHF rates are manually set and should not be auto-updated
 * 
 * Structure:
 * - rate: Amount of target currency for 1 EUR
 * - inverse: Amount of EUR for 1 unit of target currency
 */

window.currencyRates = {
  // Base currency
  'EUR': {
    code: 'EUR',
    name: 'Euro',
    rate: 1.00,
    inverse: 1.00,
    symbol: '€'
  },
  
  // Major currencies (ECB rates)
  'USD': {
    code: 'USD',
    name: 'US Dollar',
    rate: 1.1577,
    inverse: 0.8638,
    symbol: '$'
  },
  'GBP': {
    code: 'GBP',
    name: 'British Pound',
    rate: 0.8776,
    inverse: 1.1395,
    symbol: '£'
  },
  'CHF': {
    code: 'CHF',
    name: 'Swiss Franc',
    rate: 0.93,
    inverse: 1.0753,
    symbol: 'CHF'
  },
  'JPY': {
    code: 'JPY',
    name: 'Japanese Yen',
    rate: 181.09,
    inverse: 0.00552,
    symbol: '¥'
  },
  'CNY': {
    code: 'CNY',
    name: 'Chinese Yuan',
    rate: 8.1959,
    inverse: 0.1220,
    symbol: '¥'
  },
  
  // Scandinavian currencies (keeping original SEK, NOK)
  'NOK': {
    code: 'NOK',
    name: 'Norwegian Krone',
    rate: 11.83,
    inverse: 0.0845,
    symbol: 'kr'
  },
  'SEK': {
    code: 'SEK',
    name: 'Swedish Krona',
    rate: 11.02,
    inverse: 0.0907,
    symbol: 'kr'
  },
  'DKK': {
    code: 'DKK',
    name: 'Danish Krone',
    rate: 7.4687,
    inverse: 0.1339,
    symbol: 'kr'
  },
  'ISK': {
    code: 'ISK',
    name: 'Icelandic Króna',
    rate: 146.80,
    inverse: 0.00681,
    symbol: 'kr'
  },
  
  // Other European currencies (ECB rates)
  'PLN': {
    code: 'PLN',
    name: 'Polish Zloty',
    rate: 4.2313,
    inverse: 0.2363,
    symbol: 'zł'
  },
  'CZK': {
    code: 'CZK',
    name: 'Czech Koruna',
    rate: 24.168,
    inverse: 0.0414,
    symbol: 'Kč'
  },
  'HUF': {
    code: 'HUF',
    name: 'Hungarian Forint',
    rate: 382.00,
    inverse: 0.00262,
    symbol: 'Ft'
  },
  'RON': {
    code: 'RON',
    name: 'Romanian Leu',
    rate: 5.0904,
    inverse: 0.1965,
    symbol: 'lei'
  },
  'BGN': {
    code: 'BGN',
    name: 'Bulgarian Lev',
    rate: 1.9558,
    inverse: 0.5113,
    symbol: 'лв'
  },
  'HRK': {
    code: 'HRK',
    name: 'Croatian Kuna',
    rate: 7.53,
    inverse: 0.133,
    symbol: 'kn'
  },
  'RSD': {
    code: 'RSD',
    name: 'Serbian Dinar',
    rate: 117.00,
    inverse: 0.00855,
    symbol: 'RSD'
  },
  'BAM': {
    code: 'BAM',
    name: 'Bosnia-Herzegovina Convertible Mark',
    rate: 1.9558,
    inverse: 0.5113,
    symbol: 'KM'
  },
  'UAH': {
    code: 'UAH',
    name: 'Ukrainian Hryvnia',
    rate: 44.50,
    inverse: 0.0225,
    symbol: '₴'
  },
  'RUB': {
    code: 'RUB',
    name: 'Russian Ruble',
    rate: 98.00,
    inverse: 0.0102,
    symbol: '₽'
  },
  'TRY': {
    code: 'TRY',
    name: 'Turkish Lira',
    rate: 49.1459,
    inverse: 0.0204,
    symbol: '₺'
  },
  
  // Commonwealth currencies (ECB rates)
  'AUD': {
    code: 'AUD',
    name: 'Australian Dollar',
    rate: 1.7818,
    inverse: 0.5612,
    symbol: 'A$'
  },
  'NZD': {
    code: 'NZD',
    name: 'New Zealand Dollar',
    rate: 2.0395,
    inverse: 0.4903,
    symbol: 'NZ$'
  },
  'CAD': {
    code: 'CAD',
    name: 'Canadian Dollar',
    rate: 1.6309,
    inverse: 0.6132,
    symbol: 'C$'
  },
  
  // Asian currencies (ECB rates)
  'INR': {
    code: 'INR',
    name: 'Indian Rupee',
    rate: 103.2665,
    inverse: 0.00968,
    symbol: '₹'
  },
  'SGD': {
    code: 'SGD',
    name: 'Singapore Dollar',
    rate: 1.5029,
    inverse: 0.6654,
    symbol: 'S$'
  },
  'HKD': {
    code: 'HKD',
    name: 'Hong Kong Dollar',
    rate: 9.0042,
    inverse: 0.1111,
    symbol: 'HK$'
  },
  'TWD': {
    code: 'TWD',
    name: 'Taiwan Dollar',
    rate: 34.50,
    inverse: 0.0290,
    symbol: 'NT$'
  },
  'KRW': {
    code: 'KRW',
    name: 'South Korean Won',
    rate: 1706.80,
    inverse: 0.000586,
    symbol: '₩'
  },
  'THB': {
    code: 'THB',
    name: 'Thai Baht',
    rate: 37.295,
    inverse: 0.0268,
    symbol: '฿'
  },
  'MYR': {
    code: 'MYR',
    name: 'Malaysian Ringgit',
    rate: 4.7882,
    inverse: 0.2088,
    symbol: 'RM'
  },
  'IDR': {
    code: 'IDR',
    name: 'Indonesian Rupiah',
    rate: 19274.55,
    inverse: 0.0000519,
    symbol: 'Rp'
  },
  'PHP': {
    code: 'PHP',
    name: 'Philippine Peso',
    rate: 68.103,
    inverse: 0.0147,
    symbol: '₱'
  },
  'VND': {
    code: 'VND',
    name: 'Vietnamese Dong',
    rate: 27000.00,
    inverse: 0.0000370,
    symbol: '₫'
  },
  'PKR': {
    code: 'PKR',
    name: 'Pakistani Rupee',
    rate: 302.00,
    inverse: 0.00331,
    symbol: '₨'
  },
  'BDT': {
    code: 'BDT',
    name: 'Bangladeshi Taka',
    rate: 129.00,
    inverse: 0.00775,
    symbol: '৳'
  },
  'LKR': {
    code: 'LKR',
    name: 'Sri Lankan Rupee',
    rate: 325.00,
    inverse: 0.00308,
    symbol: 'Rs'
  },
  'NPR': {
    code: 'NPR',
    name: 'Nepalese Rupee',
    rate: 145.00,
    inverse: 0.00690,
    symbol: 'रू'
  },
  
  // Middle Eastern currencies
  'AED': {
    code: 'AED',
    name: 'UAE Dirham',
    rate: 3.97,
    inverse: 0.252,
    symbol: 'د.إ'
  },
  'SAR': {
    code: 'SAR',
    name: 'Saudi Riyal',
    rate: 4.05,
    inverse: 0.247,
    symbol: '﷼'
  },
  'QAR': {
    code: 'QAR',
    name: 'Qatari Riyal',
    rate: 3.94,
    inverse: 0.254,
    symbol: 'ر.ق'
  },
  'KWD': {
    code: 'KWD',
    name: 'Kuwaiti Dinar',
    rate: 0.33,
    inverse: 3.03,
    symbol: 'د.ك'
  },
  'BHD': {
    code: 'BHD',
    name: 'Bahraini Dinar',
    rate: 0.41,
    inverse: 2.44,
    symbol: '.د.ب'
  },
  'OMR': {
    code: 'OMR',
    name: 'Omani Rial',
    rate: 0.42,
    inverse: 2.38,
    symbol: 'ر.ع.'
  },
  'JOD': {
    code: 'JOD',
    name: 'Jordanian Dinar',
    rate: 0.77,
    inverse: 1.30,
    symbol: 'د.ا'
  },
  'ILS': {
    code: 'ILS',
    name: 'Israeli Shekel',
    rate: 3.7990,
    inverse: 0.2632,
    symbol: '₪'
  },
  'EGP': {
    code: 'EGP',
    name: 'Egyptian Pound',
    rate: 52.50,
    inverse: 0.0190,
    symbol: 'E£'
  },
  
  // African currencies (ECB rates where available)
  'ZAR': {
    code: 'ZAR',
    name: 'South African Rand',
    rate: 19.8458,
    inverse: 0.0504,
    symbol: 'R'
  },
  'NGN': {
    code: 'NGN',
    name: 'Nigerian Naira',
    rate: 1650.00,
    inverse: 0.000606,
    symbol: '₦'
  },
  'KES': {
    code: 'KES',
    name: 'Kenyan Shilling',
    rate: 140.00,
    inverse: 0.00714,
    symbol: 'KSh'
  },
  'GHS': {
    code: 'GHS',
    name: 'Ghanaian Cedi',
    rate: 16.50,
    inverse: 0.0606,
    symbol: '₵'
  },
  'MAD': {
    code: 'MAD',
    name: 'Moroccan Dirham',
    rate: 10.80,
    inverse: 0.0926,
    symbol: 'د.م.'
  },
  'TND': {
    code: 'TND',
    name: 'Tunisian Dinar',
    rate: 3.38,
    inverse: 0.296,
    symbol: 'د.ت'
  },
  
  // Latin American currencies (ECB rates where available)
  'BRL': {
    code: 'BRL',
    name: 'Brazilian Real',
    rate: 6.2242,
    inverse: 0.1607,
    symbol: 'R$'
  },
  'MXN': {
    code: 'MXN',
    name: 'Mexican Peso',
    rate: 21.2644,
    inverse: 0.0470,
    symbol: 'MX$'
  },
  'ARS': {
    code: 'ARS',
    name: 'Argentine Peso',
    rate: 1050.00,
    inverse: 0.000952,
    symbol: 'AR$'
  },
  'CLP': {
    code: 'CLP',
    name: 'Chilean Peso',
    rate: 1020.00,
    inverse: 0.000980,
    symbol: 'CL$'
  },
  'COP': {
    code: 'COP',
    name: 'Colombian Peso',
    rate: 4500.00,
    inverse: 0.000222,
    symbol: 'CO$'
  },
  'PEN': {
    code: 'PEN',
    name: 'Peruvian Sol',
    rate: 4.05,
    inverse: 0.247,
    symbol: 'S/'
  },
  'UYU': {
    code: 'UYU',
    name: 'Uruguayan Peso',
    rate: 44.00,
    inverse: 0.0227,
    symbol: '$U'
  },
  
  // Other currencies
  'XOF': {
    code: 'XOF',
    name: 'West African CFA Franc',
    rate: 655.96,
    inverse: 0.00152,
    symbol: 'CFA'
  },
  'XAF': {
    code: 'XAF',
    name: 'Central African CFA Franc',
    rate: 655.96,
    inverse: 0.00152,
    symbol: 'FCFA'
  }
};

/**
 * Convert EUR amount to target currency
 * @param {number} eurAmount - Amount in EUR
 * @param {string} targetCurrency - Target currency code (e.g., 'USD', 'CHF')
 * @returns {number} Converted amount
 */
window.convertFromEUR = function(eurAmount, targetCurrency) {
  const currency = window.currencyRates[targetCurrency];
  if (!currency) {
    console.warn(`Currency ${targetCurrency} not found, returning original amount`);
    return eurAmount;
  }
  return eurAmount * currency.rate;
};

/**
 * Convert from target currency to EUR
 * @param {number} amount - Amount in target currency
 * @param {string} sourceCurrency - Source currency code (e.g., 'USD', 'CHF')
 * @returns {number} Converted amount in EUR
 */
window.convertToEUR = function(amount, sourceCurrency) {
  const currency = window.currencyRates[sourceCurrency];
  if (!currency) {
    console.warn(`Currency ${sourceCurrency} not found, returning original amount`);
    return amount;
  }
  return amount * currency.inverse;
};

/**
 * Format currency amount with symbol
 * @param {number} amount - Amount to format
 * @param {string} currencyCode - Currency code (e.g., 'EUR', 'USD')
 * @param {Object} options - Formatting options
 * @returns {string} Formatted currency string
 */
window.formatCurrency = function(amount, currencyCode, options = {}) {
  const currency = window.currencyRates[currencyCode];
  if (!currency) {
    return `${amount.toFixed(2)} ${currencyCode}`;
  }
  
  const {
    decimals = 0,
    showSymbol = true,
    locale = 'de-DE'
  } = options;
  
  const formattedAmount = amount.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  
  if (showSymbol) {
    // For currencies like USD, GBP, etc., symbol goes before
    if (['USD', 'GBP', 'EUR', 'AUD', 'CAD', 'SGD', 'CNY', 'JPY'].includes(currencyCode)) {
      return `${currency.symbol}${formattedAmount}`;
    }
    // For others, symbol goes after
    return `${formattedAmount} ${currency.symbol}`;
  }
  
  return formattedAmount;
};

